<template>
    <div class="menu" v-if="show">

        <div class="chosen-menu">

                <div class="select">
                    <select id="chose-radio" v-model="currentChannelId" v-on:change="changeChannel($event)">
                        <option v-for="channel in channels" :value="channel.id">
                            {{ channel.name }}
                        </option>
                    </select>
                </div>


                <div class="type-wrap">
                    <router-link to="/mod" class="type" :id="$route.path==='/mod' ? 'active' : ''">Radio</router-link>
                </div>
                <div class="type-wrap">
                    <router-link to="/podcast" class="type" :id="$route.path==='/podcast' ? 'active' : ''" >Podcast</router-link>
                </div>
                <div class="type-wrap">
                    <a href="#" class="type">Slides</a>
                </div>

            <div id="listeners">
                <span class="current">{{listeners.current}} / {{listeners.last_week}} / {{listeners.last_month}} / {{listeners.total}}</span>
            </div>

        </div>

        <div class="header-btn-donate-wrap">
            <a class="header-btn-donate" @click="showModal">создать поток</a>
        </div>

        <create-channel-modal/>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import CreateChannelModal from '../modals/CreateChannelModal'

  export default {
    components: {
      CreateChannelModal
    },
    props: {
      show: Boolean
    },

    data () {
      return {
        channels: null,
        currentChannelId: 1,
        listeners: {
          current: 0,
          last_week: 0,
          last_month: 0,
          total: 0,
        }
      }
    },

    watch: {
      'currentChannelId': function (val, oldVal) {
        this.setCurrentChannel(val)
      }
    },


    methods: {
      ...mapActions([
        'toggleSidebar'
      ]),
      logout () {
        this.$auth.logout({
          redirect: 'Home',
          makeRequest: false
        })
      },

      getAllChannels () {
        this.$http.get('/api/channels')
          .then(response => {
            this.channels = response.data
          })
      },

      getCurrentChannel () {
        if (!this.$store.state.channel_id) {
          this.setCurrentChannel()
        }
        this.currentChannelId = this.$store.state.channel_id
      },

      setCurrentChannel (id) {
        this.$store.commit('updateChannel', id ? id : this.channels ? this.channels[0].id : 1)
      },

      changeChannel () {
        this.setCurrentChannel(this.currentChannelId)
      },

      showModal () {
        this.$modal.show('channels-modal',{channels: this.channels})
      },

      getListenersCount () {
        this.$http.get('/api/channels/listeners')
          .then(response => {
            this.listeners.current = response.data.current_listeners
          })
      }
      
    },

    mounted () {
      this.getAllChannels()
      this.getCurrentChannel()
      this.getListenersCount()
    }
  }
</script>
<style>
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .2s ease;
    }

    .slide-fade-enter {
        transform: translateY(-50px);
        opacity: 0;
    }

    .slide-fade-leave-to {
        transform: translateY(-50px);
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/NavbarAdmin.vue